export const VYV_GESTION_DONNEES = "https://vyv-conseil.fr/gestions-donnees-personnelles/";
export const USE_COOKIES_TRUE = "?useCookies=true";
export const USE_COOKIES_FALSE = "?useCookies=false";
